<template>
  <div class="ads-group-setting">
    <el-page-header @back="goBack" :content="title">
    </el-page-header>
    <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal">
      <el-menu-item v-for="item in componentsList" :key="item.id" :index="item.id" @click="() => {setComponents(item)}">
        {{item.text}}
      </el-menu-item>
    </el-menu>
    <transition name="router-slid" mode="out-in">
      <keep-alive>
        <component :is="currentComponent"></component>
      </keep-alive>
    </transition>
  </div>
</template>

<script>
import adsPutInAuto from './children/AdsPutInAuto'
import adsPutInKey from './children/AdsPutInKey'
import adsPutInProd from './children/AdsPutInProd'
import searchKey from './children/SearchKey'
import adsNegativeKey from './children/AdsNegativeKey'
import adsNegativeProd from './children/AdsNegativeProd'
import skuMgmt from './children/SkuMgmt'

export default {
  data() {
    return {
      activeIndex: '1',
      currentComponent: 'adsPutInAuto',
      adsType: null,
      title: "广告组设置",
      tabSearchKey: {
        id: '4',
        text: '搜索词',
        name: 'searchKey'
      },
      tabSku: {
        id: '7',
        text: 'SKU',
        name: 'skuMgmt'
      },
      operateList: [
        {
          id: '1',
          text: '投放',
          name: 'adsPutInAuto'
          // 自动
        },
        {
          id: '2',
          text: '投放',
          name: 'adsPutInKey'
          // 关键词
        },
        {
          id: '3',
          text: '投放',
          name: 'adsPutInProd'
          // 商品
        }
      ],
      operateList1: [
        {
          id: '5',
          text: '否定关键词',
          name: 'adsNegativeKey'
        },
        {
          id: '6',
          text: '否定商品',
          name: 'adsNegativeProd'
        }
      ],
      componentsList: []
    }
  },
  components: {
    adsPutInAuto,
    adsPutInKey,
    adsPutInProd,
    searchKey,
    adsNegativeKey,
    adsNegativeProd,
    skuMgmt
  },
  created() {

  },
  activated() {
    // route.params.absType 1 2 自动, 4 关键词 3 5商品
    this.adsType = ['', 0, 0, 2, 1, 2][this.$route.query.absType];
    this.componentsList = this.getComponentsList();
    this.setComponents(this.componentsList[0]);
    this.title = "广告组设置->";
    this.$route.query.absType == 1 && (this.title += "自动关联商品");
    this.$route.query.absType == 2 && (this.title += "自动紧密匹配");
    this.$route.query.absType == 3 && (this.title += "手动关联商品");
    this.$route.query.absType == 4 && (this.title += "手动紧密匹配关键词");
    this.$route.query.absType == 5 && (this.title += "手动亚马逊关联商品");
    this.title += "->" + this.$route.query.asin + "(" + this.$route.query.name + ")";

  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getComponentsList() {
      if (this.adsType < 1) {
        return [this.tabSearchKey, this.operateList[this.adsType], this.tabSku, ...this.operateList1];
      }
      return [this.tabSearchKey, this.operateList[this.adsType], this.tabSku, this.operateList1[this.adsType - 1]];
    },
    setComponents(item) {
      this.activeIndex = item.id;
      this.currentComponent = item.name;
    }
  }
}
</script>

<style lang="scss">
.ads-group-setting {
  .el-page-header {
    padding: 20px 0px;
    border-bottom: solid 1px #e6e6e6;
  }

  .el-menu-item {
    a {
      text-decoration: none;
    }
  }

  .header-box {
    .el-button {
      width: auto;
    }
  }
  .el-table .cell,
  .el-table--border td:first-child .cell,
  .el-table--border th:first-child .cell {
    padding-left: 10px;
  }
}
</style>
